export default __webpack_public_path__ + "static/media/error_image.6310a4b3.svg";